
var id = "emp_analysis";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"emp_analysis\">\n<style type=\"text/css\">\n\t#emp_analysis .st0{}\n\t#emp_analysis .st1{}\n</style>\n<filter id=\"emp_analysis_filter-1\">\n\t<feColorMatrix in=\"SourceGraphic\" type=\"matrix\" values=\"0 0 0 0 0.082353 0 0 0 0 0.396078 0 0 0 0 0.752941 0 0 0 1.000000 0\">\n\t\t</feColorMatrix>\n</filter>\n<title>会员分析</title>\n<g id=\"emp_analysis_控件\">\n\t<g id=\"emp_analysis_左侧菜单---订单管理-\" transform=\"translate(-32.000000, -232.000000)\">\n\t\t<g id=\"emp_analysis_会员分析\" transform=\"translate(0.000000, 216.000000)\" class=\"st0\">\n\t\t\t<g transform=\"translate(32.000000, 16.000000)\">\n\t\t\t\t<path id=\"emp_analysis_形状_1_\" class=\"st1\" d=\"M7.9,0c1.9,0,3.7,1.3,4.2,3.2S11.9,7,10.2,8.1c1,0.3,2,0.8,2.8,1.6c0.2,0.2,0.2,0.6,0,0.8\n\t\t\t\t\tc-0.2,0.2-0.5,0.3-0.8,0.1C11,9.6,9.5,8.9,7.9,8.9c-3.5,0-6.4,2.7-6.7,6.2c0,0.3-0.3,0.5-0.6,0.5C0.2,15.6,0,15.3,0,15\n\t\t\t\t\tc0.3-3.3,2.6-6,5.6-6.9C3.9,7,3.2,5,3.7,3.2S5.9,0,7.9,0z M7.9,1.2c-1.1,0-2.2,0.6-2.8,1.6S4.5,5,5.1,6s1.6,1.6,2.8,1.6\n\t\t\t\t\tc1.7,0,3.1-1.4,3.1-3.2S9.6,1.2,7.9,1.2z M11.6,16c-0.1,0-0.3-0.1-0.4-0.1s-0.1-0.2-0.1-0.4v-2c0-0.3,0.2-0.5,0.5-0.5\n\t\t\t\t\ts0.5,0.2,0.5,0.5v2c0,0.1-0.1,0.3-0.1,0.4S11.7,16,11.6,16L11.6,16z M13.5,16L13.5,16c-0.1,0-0.3-0.1-0.4-0.1\n\t\t\t\t\tc-0.1-0.1-0.1-0.2-0.1-0.4l0-4.4c0-0.3,0.2-0.5,0.5-0.5h0c0.3,0,0.5,0.2,0.5,0.5l0,4.4C14,15.7,13.8,16,13.5,16L13.5,16z\n\t\t\t\t\t M15.4,16c-0.3,0-0.5-0.2-0.5-0.5v-3.2c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v3.2c0,0.1-0.1,0.3-0.1,0.4S15.5,16,15.4,16\n\t\t\t\t\tL15.4,16z\" />\n\t\t\t</g>\n\t\t</g>\n\t</g>\n</g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
